import React from 'react';
import OutboundLink from '../OutboundLink';
import { TextInput, Checkbox, Select, TextArea } from '../Form';
import { Link } from 'gatsby';
import { months, days, years } from './birthday';

const schema = {
  firstName: {
    label: 'Name',
    component: TextInput,
    type: 'text',
    placeholder: 'Name',
    required: false,
  },
  email: {
    label: 'Email',
    component: TextInput,
    type: 'email',
    value: '',
    placeholder: 'email@address.com',
    required: true,
    validation: {
      test: (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value),
      message: 'Please provide a valid email address.',
    },
  },
  school: {
    label: 'School, Organization or District Name',
    component: TextInput,
    type: 'text',
    placeholder: 'Rose Elementary',
    required: false,
  },
  month: {
    label: 'Month',
    component: Select,
    placeholder: 'Month',
    options: months,
    value: '',
    required: true,
    labelHidden: true,
  },
  day: {
    label: 'Day',
    component: Select,
    placeholder: 'Day',
    options: days,
    value: '',
    required: true,
    labelHidden: true,
  },
  year: {
    label: 'Year',
    component: Select,
    placeholder: 'Year',
    options: years,
    value: '',
    required: true,
    labelHidden: true,
  },
  question: {
    label: 'Your Question to the Data Expert',
    component: TextArea,
    type: 'textarea',
    value: '',
    required: true,
  },
  subscribeToDE: {
    label: (
      <>
        By clicking this box, you agree to <a href="https://www.discoveryeducation.com/privacy-policy/">Discovery Education’s Privacy Policy</a> and to the  <Link to="/discover-data-privacy/">Nielsen Foundation’s Privacy Policy</Link>. Both entities may contact you as described in their policies.
      </>
    ),
    component: Checkbox,
    checked: false,
  },
  subscribeToPartner: {
    label: (programName, partnerPrivacyUrl) => (
      <>
        I would like to receive information about the other STEM education
        topics from {programName} in accordance with the following{' '}
        <OutboundLink to="https://www.discoveryeducation.com/privacy-policy">Privacy Policy</OutboundLink>.
      </>
    ),
    component: Checkbox,
    checked: false,
  },
};

export default schema;
